import Vue from "vue";

export function pageApproveApi(params, success,complete) {
    let url = "/admin/web/approve/pageApprove";
    Vue.prototype.alexPost(url, params, success,null,complete);
}

export function auditApi(params, success) {
    let url = "/admin/web/approve/audit";
    Vue.prototype.alexPost(url, params, success);
}


